"use client";

import { createContext, useContext, useState, ReactNode, useCallback } from "react";

type BookingPriceContextType = {
  selectedTierPrice: number | undefined;
  setTierPrice: (price: number) => void;
  resetTierPrice: () => void;
};

const BookingPriceContext = createContext<BookingPriceContextType | undefined>(
  undefined,
);

export function BookingPriceProvider({ children }: { children: ReactNode }) {
  const [selectedTierPrice, setSelectedTierPrice] = useState<number | undefined>(
    undefined,
  );

  const setTierPrice = useCallback((price: number) => {
    setSelectedTierPrice(price);
  }, []);

  const resetTierPrice = useCallback(() => {
    setSelectedTierPrice(undefined);
  }, []);

  return (
    <BookingPriceContext.Provider
      value={{ selectedTierPrice, setTierPrice, resetTierPrice }}
    >
      {children}
    </BookingPriceContext.Provider>
  );
}

export function useBookingPrice() {
  const context = useContext(BookingPriceContext);
  // Return a safe default if context is not available (fallback for components
  // that might be used outside the provider, or during SSR edge cases)
  return context || { selectedTierPrice: undefined, setTierPrice: () => {}, resetTierPrice: () => {} };
}
